export default __webpack_public_path__ + "static/fan_b.2875fea394237adb5708619c47643e78.svg";